module.exports = __webpack_public_path__ + "static/img/icon-setting3.8284fc7e.svg";